/**
 * StationByImei.js
 *
 * Page component for searching and displaying weather station data by IMEI number.
 * This page provides a simple form interface for users to enter an IMEI number
 * and view the corresponding station data.
 *
 * The page supports URL parameters, so users can share direct links to station data
 * by including the IMEI in the URL (e.g., /station-by-imei/300434063298940).
 */

import React from "react";
import { useParams } from "react-router-dom";
import ImeiSearchForm from "../components/ImeiSearch/ImeiSearchForm";

/**
 * StationByImei page component
 *
 * @returns {JSX.Element} The rendered station by IMEI page
 */
const StationByImei = () => {
  // Get IMEI from URL parameters if available
  const { imei } = useParams();

  return <ImeiSearchForm initialImei={imei} />;
};

export default StationByImei;
